/**
 *
 */
export function handlePopup() {

	const openLinks = document.querySelectorAll( 'a[href="#popup"]' );
	const popup = document.getElementById( 'popup' );
	const closeBtn = document.querySelector( '.popup__close' );
	const popupContent = document.querySelector( '.popup__content' );
	const iframe = document.querySelector( '.popup__iframe' );
	const buttonIframe = document.querySelector( '.popup__button--iframe' );

	if ( openLinks.length > 0 && popup ) {

		openLinks.forEach( function openPopupButtons ( openLink ) {

			openLink.addEventListener( 'click', function openPopup( e ) {

				e.preventDefault();
				popup.classList.add( 'popup--opened' );

			} );

		} );

		closeBtn.addEventListener( 'click', function closePopup( e ) {

			e.preventDefault();
			popup.classList.remove( 'popup--opened' );
			popup.classList.remove( 'popup--with-iframe' );
			iframe.style.display = 'none';

			// Handle iFrames run from native buttons.
			popup.style.opacity = ''
			popup.style.visibility = ''

		} );

		document.body.addEventListener( 'click', function closePopupOnClickOutside ( e ) {

			if ( ! popupContent.contains( e.target ) && popup.classList.contains( 'popup--opened' ) ) {

				if ( ! e.target.closest( 'a[href="#popup"]' ) ) {

					popup.classList.remove( 'popup--opened' );
					popup.classList.remove( 'popup--with-iframe' );
					iframe.style.display = 'none';

				}

			}

		} );

	}

	buttonIframe.addEventListener( 'click', function handleIframe ( event ) {

		event.preventDefault();
		iframe.style.display = 'block';
		popup.classList.add( 'popup--with-iframe' );

	} );

}
